import { DataTable } from "@/components/DataTable";
import { getSosEntityLineItemHashId } from "@/components/SosEntityLineItemHashLink";
import { TableWrapper } from "@/components/TableWrapper";
import { withJobTrackingData } from "../withJobTrackingData";
import { shipmentTableColumns, ShipmentTableRow } from "./shipments-table-columns";

export const Shipments = withJobTrackingData(({ shipments }) => {
  // Flatten the list of shipments into a list of table rows (one row for each line item)
  const data = shipments.flatMap((shipment) =>
    shipment.jobLines.map<ShipmentTableRow>((line, index) => ({
      rowId: getSosEntityLineItemHashId("shipment", shipment.id, index),
      shipment,
      line,
    })),
  );

  return (
    <TableWrapper className="col">
      <DataTable
        bordered
        hover
        data={data}
        columns={shipmentTableColumns}
        getRowId={({ rowId }) => rowId}
        initialState={{
          sorting: [{ id: "shipment_date", desc: true }],
        }}
      />
    </TableWrapper>
  );
});
